import styled from 'styled-components';
export var ShowMore = styled.span.withConfig({
  displayName: "ShowMore",
  componentId: "sc-1xe0uew-0"
})(["padding:3px 12px;border-radius:", ";cursor:pointer;&:hover{background-color:", ";color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.lightGrey;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mainColor;
});